import React, { useEffect, useState, useRef, useContext } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import axios from "axios";
import {
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Typography,
  Tooltip,
  Chip,
  Snackbar,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { useChatRecentListMutation, useUserChatNameListMutation } from "../../redux/UserChat/UserChat.api";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import OR_Logo from "../../../src/assets/or1.svg";
import { Networking } from "../../reusable_components/components/Networking";
import AttachmentIcon from '@mui/icons-material/Attachment';
import { set } from "react-hook-form";
import { FiSend } from "react-icons/fi";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

let stompClient = null;

const UserChat = () => {
  const subscriptionRef = useRef(null);
  const [user, setUser] = useState(String(localStorage.getItem("userId")));
  const [receiverId, setReceiverId] = useState(null);
  const [receiverName, setReceiverName] = useState("");
  const [message, setMessage] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [chatHistorys, setChatHistorys] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const connectedRef = useRef(false);
  const [chatRecentList] = useChatRecentListMutation();
  const [chatNameList] = useUserChatNameListMutation();
  const [userList, setUserList] = useState([]);
  const [searchChatName, setSearchChatName] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const messagesEndRef = useRef(null);
  const [NetworkingLoss, setNetworkingLoss] = useState(false);
  const [drafts, setDrafts] = useState({});
  const [activeTab, setActiveTab] = useState("chats");
  const [allUserList, setAllUserList] = useState([])

  const { Snackbar } = useContext(SnackbarContext)

  const [isOnline, setIsOnline] = useState(navigator.onLine);


  // api's
  const [getInternalUserList] = useUserChatNameListMutation()



  // const userChatList = async () => {
  //   try {
  //     const payload = {
  //       chatName: searchChatName || "",
  //     };
  //     const response = await chatRecentList(payload).unwrap();
  //     setUserList(response?.response?.chatNameList);

  //     const savedUserStr = localStorage.getItem("selectedUser");
  //     let savedUser = null;

  //     try {
  //       if (savedUserStr) {
  //         savedUser = JSON.parse(savedUserStr);
  //       }
  //     } catch (error) {
  //       console.warn("Invalid saved user in localStorage, clearing...");
  //       localStorage.removeItem("selectedUser");
  //     }

  //     const foundUser = response.response.chatNameList?.find(
  //       (u) => u.userId === savedUser?.userId
  //     );

  //     if (foundUser) {
  //       setSelectedUser(foundUser);
  //       setReceiverId(foundUser.userId);
  //       setReceiverName(foundUser.fullName);
  //     } else if (!selectedUser && response.response.length > 0) {
  //       const fallbackUser = response.response[0];
  //       setSelectedUser(fallbackUser);
  //       setReceiverId(fallbackUser.userId);
  //       setReceiverName(fallbackUser.fullName);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user list:", error);
  //   }
  // };

  const connect = () => {
    const socket = new SockJS(`${window.REACT_APP_FILEDOWNLOAD_URL}:8444/Openrecruiter/ws`);

    stompClient = new Client({
      webSocketFactory: () => socket,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 5000,
      reconnectDelay: 5000,

      onConnect: () => {
        subscribeToChat();
        subscribeToRecentChat();
        connectedRef.current = true;
        setIsConnected(true);
        setNetworkingLoss(true);

        console.log("✅ Connected to WebSocket");

        // Request recent chat list
        if (stompClient && stompClient.connected && user) {
          console.log("About to publish recent chat list request...");
          stompClient.publish({
            destination: "/app/chat-recent-list",
            body: JSON.stringify({ userId: user })
          });
          console.log("Requested recent chat list from backend for user:", user);
        }
      },

      onDisconnect: () => {
        connectedRef.current = false;
        setIsConnected(false);
        setNetworkingLoss(false);
        console.log("⚠️ Disconnected from WebSocket");
      },

      onStompError: (frame) => {
        console.error("❌ Broker error: " + frame.headers["message"]);
        console.error("Details: " + frame.body);
      },
    });

    stompClient.activate();
  };

  const subscribeToChat = () => {
    if (!user || !receiverId || !stompClient || !stompClient.connected) return;

    if (subscriptionRef.current) {
      subscriptionRef.current.unsubscribe();
      subscriptionRef.current = null;
    }

    let [userA, userB] = [user, receiverId];
    if (userA > userB) [userA, userB] = [userB, userA];

    const topic = `/topic/private.${userA}.${userB}`;

    const subscription = stompClient.subscribe(topic, (msg) => {
      console.log("Received msg.body:", msg.body);

      const receivedMessage = JSON.parse(msg.body);
      // fetchChatHistory()

      console.log("Received message:", receivedMessage);

      if (receivedMessage?.senderId !== +user) {
        setChatHistory((prev) => [...prev, receivedMessage]);
      } else {
        console.log("not added");

      }


      setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 50);
    });

    subscriptionRef.current = subscription;
  };


  const [notificationQueue, setNotificationQueue] = useState([]);
  const [isToastShowing, setIsToastShowing] = useState(false);
  const queueRef = useRef([]); // mutable queue reference
  const [trigger, setTrigger] = useState(false);

  // Watch queue and display one-by-one
  useEffect(() => {
    if (!isToastShowing && queueRef.current.length > 0) {
      const nextMessage = queueRef.current.shift(); // take first in line
      setIsToastShowing(true);
      triggerNotify(nextMessage);
    }
  }, [notificationQueue, isToastShowing]);

  const triggerNotify = (chatSummary) => {
    console.log("Triggering notification for chatSummary:", chatSummary);

    if (chatSummary?.senderId !== +user) {
      toast.info(
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            {chatSummary.fullNameChat}
          </Typography>
          <Typography variant="body2" sx={{ color: '#333' }}>
            {chatSummary.content}
          </Typography>
        </Box>,
        {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: chatSummary?.chatId,
          onClose: () => {
            setIsToastShowing(false); // let the next one trigger
          }
        }
      );
    }
  };


  const location = useLocation();

  const path = location?.pathname.split('/')
  const pathName = path[1]

  const [backUpUserList, setBackUpUserList] = useState([]);

  const subscribeToRecentChat = () => {
    if (!user || !stompClient || !stompClient.connected) return;

    stompClient.subscribe('/topic/chat-recent-list/' + user, function (message) {
      try {
        const chatSummaries = JSON.parse(message.body);
        const savedUserStr = localStorage.getItem("selectedUser");
        let savedUser = null;
        console.log("Recent Chat Summaries:", chatSummaries);
        setUserList(chatSummaries);
        setBackUpUserList(chatSummaries);

        try {
          if (savedUserStr) {
            savedUser = JSON.parse(savedUserStr);
          }
        } catch (error) {
          localStorage.removeItem("selectedUser");
        }

        const foundUser = chatSummaries?.find(
          (u) => u.userId === savedUser?.userId
        );

        if (foundUser) {
          setUserList(chatSummaries);
          setSelectedUser(foundUser);
          setReceiverId(foundUser.userId);
          setReceiverName(foundUser.fullName);
        } else if (!selectedUser && foundUser.length > 0) {
          const fallbackUser = foundUser.response[0];
          setSelectedUser(fallbackUser);
          setReceiverId(fallbackUser.userId);
          setReceiverName(fallbackUser.fullName);
        }


      } catch (err) {
        console.error("Error parsing recent chat list :", err, message.body);
      }
    });

    if (!user || !stompClient || !stompClient.connected) return;

    stompClient.subscribe('/topic/chat-recent/' + user, function (message) {
      try {
        const chatSummary = JSON.parse(message.body);
        console.log("Recent Notify:", chatSummary);

        if (localStorage?.length === 0) {
          return null
        } else {
          queueRef.current.push(chatSummary);
          setNotificationQueue([...queueRef.current]);

          if (pathName === 'userchat') {
            toast.info(
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                  {chatSummary.fullNameChat}
                </Typography>
                <Typography variant="body2" sx={{ color: '#333' }}>
                  {chatSummary.content}
                </Typography>
              </Box>,
              {
                position: "top-left",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                toastId: chatSummary?.chatId,
              }
            );

          }
        }

      } catch (err) {
        console.error("Error parsing chat notification:", err, message.body);
      }
    });

  };

  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

  const lastReceipientId = userList[0]?.userId
  const [startFirstFetch, setStartFirstFetch] = useState(true)

  const fetchChatHistory = async (selectUser) => {
    const user2Id = user
      ? selectUser?.userId
      : receiverId || lastReceipientId;

    if (!user || !user2Id) return;

    try {
      const res = await axios.get(
        `${window.REACT_APP_FILEDOWNLOAD_URL}:8444/Openrecruiter/messages`,
        { params: { user1: user, user2: user2Id } }
      );
      setChatHistory(res.data);
      stompClient.publish({
        destination: "/app/chat-recent-list",
        body: JSON.stringify({ userId: user })
      });
    } catch (err) {
      console.error("Failed to fetch chat history", err);
    }
  };


  const initialFetchDoneRef = useRef(false);

  useEffect(() => {
    if (!initialFetchDoneRef.current && userList.length > 0) {
      let savedUser = null;
      const savedUserStr = localStorage.getItem("selectedUser");

      if (savedUserStr) {
        try {
          savedUser = JSON.parse(savedUserStr);
        } catch (e) {
          localStorage.removeItem("selectedUser");
        }
      }

      // Check if saved user exists in current userList
      const foundUser = savedUser
        ? userList.find((u) => u.userId === savedUser.userId)
        : null;

      const targetUser = foundUser || userList[0];

      if (targetUser && !searchChatName) {
        setSelectedUser(targetUser);
        setReceiverId(targetUser.userId);
        setReceiverName(targetUser.fullName);
        fetchChatHistory(targetUser);
      }

      initialFetchDoneRef.current = true;
    }
  }, [userList]);

  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);

  const sendMessage = () => {
    if (!message.trim()) return;
    if (stompClient && stompClient.connected) {
      const chatMsg = {
        sender: +user,
        receiver: receiverId,
        content: message.trim(),
        timestamp: new Date(new Date().getTime() - (5.5 * 60 * 60 * 1000))
      };

      stompClient.publish({
        destination: "/app/chat.private",
        body: JSON.stringify(chatMsg),
      });
      setActiveTab("chats")
      setSearchChatName("")
      setChatHistory((prev) => [...prev, { ...chatMsg, sender: user }]);
      setMessage("");
      setDrafts((prev) => ({
        ...prev,
        [receiverId]: "",
      }));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (message.trim()) {
        sendMessage();
      }
    }
  };

  const handleUserSelect = (user) => {
    fetchChatHistory(user);

    if (!user || user.userId === receiverId) return;

    if (receiverId) {
      setDrafts((prev) => ({
        ...prev,
        [receiverId]: message,
      }));
    }

    setSelectedUser(user);
    setReceiverId(user.userId);
    setReceiverName(user.fullName);
    setChatHistory([]);
    setMessage(drafts[user.userId] || "");
    localStorage.setItem("selectedUser", JSON.stringify(user));
    const selectUser = user;

    if (connectedRef.current) {
      fetchChatHistory(selectUser);
      subscribeToChat();
      // userChatList();
    }
  };

  // useEffect(() => {

  //   const searchUserList = async () => {
  //     try {
  //       const payload = {
  //         chatName: searchChatName || "",
  //       };
  //       const response = await chatNameList(payload).unwrap();
  //       if (response?.response?.data) {
  //         setUserList(response?.response?.data)
  //       } else {
  //         setUserList(backUpUserList);
  //       }
  //     } catch (error) {
  //       console.error("Error searching user list:", error);
  //       setUserList([]);
  //     }
  //   }
  //   searchUserList()

  // }, [searchChatName]);


  const filterChatUser = userList?.filter?.((item) =>
    item?.fullName?.toLowerCase()?.startsWith(searchChatName?.toLowerCase())
  )

  const filterAllUser = allUserList?.data?.filter?.((item) =>
    item?.fullName?.toLowerCase()?.startsWith(searchChatName?.toLowerCase())
  )

  const visibleAllUsers = searchChatName
    ? filterAllUser
    : allUserList?.data;


  const visibleUsers = searchChatName
    ? filterChatUser
    : userList;




  useEffect(() => {
    if (user && !connectedRef.current) {
      connect();
    } else if (user && receiverId) {
      subscribeToChat();
      // fetchChatHistory();
    }
  }, [user, receiverId]);

  useEffect(() => {
    const savedUserStr = localStorage.getItem("selectedUser");
    if (savedUserStr) {
      try {
        const parsedUser = JSON.parse(savedUserStr);
        setSelectedUser(parsedUser);
        setReceiverId(parsedUser.userId);
        setReceiverName(parsedUser.fullName);
      } catch (e) {
        console.error("Invalid selectedUser in localStorage", e);
        localStorage.removeItem("selectedUser");
      }
    }
  }, []);

  useEffect(() => {
    if (selectedUser && drafts[selectedUser.userId] !== undefined) {
      setMessage(drafts[selectedUser.userId]);
    }
  }, [selectedUser]);

  // 📅 Group messages by date
  const groupedMessages = chatHistory.reduce((groups, msg) => {
    const dateKey = dayjs(msg.timestamp).format("YYYY-MM-DD");
    if (!groups[dateKey]) groups[dateKey] = [];
    groups[dateKey].push(msg);
    return groups;
  }, {});



  function formatToIST(timestamp) {
    const utcDate = new Date(timestamp);
    const istOffsetMs = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(utcDate.getTime() + istOffsetMs);

    const yyyy = istDate.getFullYear();
    const mm = String(istDate.getMonth() + 1).padStart(2, '0');
    const dd = String(istDate.getDate()).padStart(2, '0');

    let hours = istDate.getHours();
    const minutes = String(istDate.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const hh = String(hours).padStart(2, '0');

    return `${hh}:${minutes} ${ampm}`;
  }

  const getUserNameList = async () => {

    try {
      const response = await getInternalUserList().unwrap()
      setAllUserList(response?.response)
      console.log("response", response);

    } catch (error) {
      Snackbar("Network error", 'error')
    }
  }

  useEffect(() => {
    getUserNameList()
  }, [])

  return (
    <Box sx={{ display: "flex", flexDirection: "row", height: "100vh" }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: "25%",
          height: "100vh",
          borderRight: "1px #e0e0e0 solid",
          p: "8px 2px",
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#f9f9f9",
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            fontWeight: "bold",
            fontSize: "20px",
            fontFamily: "Lucida Console",
            padding: "16px 4px 8px 4px",
          }}
        >
          CHAT
        </Box>
        <TextField
          variant="outlined"
          placeholder="Search People"
          value={searchChatName}
          onChange={(e) => setSearchChatName(e.target.value)}
          InputProps={{
            startAdornment: (
              <SearchIcon sx={{ color: "action.active", mr: 1 }} />
            ),
          }}
          sx={{

            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              height: "55%",
              margin: 1,
              borderRadius: '20px'
            },
          }}
        />

        <Box sx={{ display: "flex", borderBottom: "1px solid #ddd", mb: 1 }}>
          <Box
            onClick={() => setActiveTab("chats")}
            sx={{
              flex: 1,
              textAlign: "center",
              cursor: "pointer",
              fontWeight: activeTab === "chats" ? "bold" : "normal",
              borderBottom: activeTab === "chats" ? "2px solid #53389E" : "none",
              color: activeTab === "chats" ? "#53389E" : "#555",
              fontFamily: 'Robotic'
            }}
          >
            Chats
          </Box>
          <Box
            onClick={() => setActiveTab("users")}
            sx={{
              flex: 1,
              textAlign: "center",
              cursor: "pointer",
              fontWeight: activeTab === "users" ? "bold" : "normal",
              borderBottom: activeTab === "users" ? "2px solid #53389E" : "none",
              color: activeTab === "users" ? "#53389E" : "#555",
              fontFamily: 'Robotic'
            }}
          >
            Users
          </Box>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: "3px" },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "3px",
            },
          }}
        >

          {
            activeTab === "chats" ? (
              <List>

                {

                  Array.isArray(visibleUsers) && visibleUsers.length > 0 ? (
                    visibleUsers.map((user, index) => {
                      const backgroundColor = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "red",
                      ][index % 7];

                      const displayMsg = (() => {
                        const msg = user.lastMessageContent || "";
                        return msg.length > 15
                          ? msg.slice(0, 15).replace(/^./, (c) => c.toUpperCase()) + "..."
                          : msg.replace(/^./, (c) => c.toUpperCase());
                      })();

                      return (
                        <ListItem
                          key={user.userId}
                          onClick={() => handleUserSelect(user)}
                          sx={{
                            mb: 0.5,
                            py: 1,
                            backgroundColor:
                              selectedUser?.userId === user.userId ? "#e0e0e0" : "inherit",
                            "&:hover": { backgroundColor: "#f5f5f5", cursor: "pointer" },
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* Left: Avatar + Text */}
                          <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                            <Avatar
                              sx={{
                                height: 34,
                                width: 34,
                                bgcolor: backgroundColor,
                                fontSize: "14px",
                                flexShrink: 0,
                              }}
                            >
                              {user?.fullName?.charAt(0)}
                            </Avatar>

                            <Box sx={{ ml: 1, width: "100%" }}>
                              {/* Row 1: Name + Unread */}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#53389E",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {user.fullName}<br></br>
                                  <span style={{ fontSize: "12px", color: "#14960B" }}>
                                    {user?.roleName === "recruiter"
                                      ? "Recruiter"
                                      : user?.roleName === "admin"
                                        ? "Admin"
                                        : user?.roleName === "Coordinator"
                                          ? "Coordinator"
                                          : ""
                                    }
                                  </span>
                                </Typography>

                                {user?.unreadMessagesCount > 0 && (
                                  <Box
                                    sx={{
                                      backgroundColor: "green",
                                      color: "#fff",
                                      borderRadius: "12px",
                                      minWidth: "16px",
                                      height: "16px",
                                      fontSize: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: "bold",
                                      ml: 1,
                                      px: "4px",
                                    }}
                                  >
                                    {user.unreadMessagesCount}
                                  </Box>
                                )}
                              </Box>

                              {/* Row 2: Last message + Time */}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#555",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "70%",
                                  }}
                                >
                                  {displayMsg}
                                </Typography>

                                <Typography sx={{ fontSize: "10px", color: "#888" }}>
                                  {user.timestamp
                                    ? formatToIST(user.timestamp)
                                    : ""}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </ListItem>
                      );
                    })
                  ) : (
                    <Typography sx={{ p: 2, color: "#888", textAlign: "center" }}>
                      No People Found!
                    </Typography>
                  )
                }
              </List>
            ) : (
              <List>
                {
                  visibleAllUsers?.length > 0 ? (
                    visibleAllUsers?.map((user, index) => {
                      const backgroundColor = [
                        "green",
                        "darkorange",
                        "purple",
                        "#3357FF",
                        "orangered",
                        "darkgreen",
                        "red",
                      ][index % 7];

                      const displayMsg = (() => {
                        const msg = user.lastMessageContent || "";
                        return msg.length > 15
                          ? msg.slice(0, 15).replace(/^./, (c) => c.toUpperCase()) + "..."
                          : msg.replace(/^./, (c) => c.toUpperCase());
                      })();

                      return (
                        <ListItem
                          key={user.userId}
                          onClick={() => handleUserSelect(user)}
                          sx={{
                            mb: 0.5,
                            py: 1,
                            backgroundColor:
                              selectedUser?.userId === user.userId ? "#e0e0e0" : "inherit",
                            "&:hover": { backgroundColor: "#f5f5f5", cursor: "pointer" },
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          {/* Left: Avatar + Text */}
                          <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0 }}>
                            <Avatar
                              sx={{
                                height: 34,
                                width: 34,
                                bgcolor: backgroundColor,
                                fontSize: "14px",
                                flexShrink: 0,
                              }}
                            >
                              {user?.fullName?.charAt(0)}
                            </Avatar>

                            <Box sx={{ ml: 1, width: "100%" }}>
                              {/* Row 1: Name + Unread */}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: "'Inter', sans-serif",
                                    fontWeight: "bold",
                                    color: "#53389E",
                                    fontSize: "14px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {user.fullName}<br></br>
                                  <span style={{ fontSize: "12px", color: "#14960B" }}>
                                    {user?.roleName === "recruiter"
                                      ? "Recruiter"
                                      : user?.roleName === "admin"
                                        ? "Admin"
                                        : user?.roleName === "coordinator"
                                          ? "Coordinator"
                                          : ""
                                    }
                                  </span>
                                </Typography>

                                {user?.unreadMessagesCount > 0 && (
                                  <Box
                                    sx={{
                                      backgroundColor: "green",
                                      color: "#fff",
                                      borderRadius: "12px",
                                      minWidth: "16px",
                                      height: "16px",
                                      fontSize: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: "bold",
                                      ml: 1,
                                      px: "4px",
                                    }}
                                  >
                                    {user.unreadMessagesCount}
                                  </Box>
                                )}
                              </Box>

                              {/* Row 2: Last message + Time */}
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "12px",
                                    color: "#555",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "70%",
                                  }}
                                >
                                  {displayMsg}
                                </Typography>

                                <Typography sx={{ fontSize: "10px", color: "#888" }}>
                                  {user.timestamp
                                    ? formatToIST(user.timestamp)
                                    : ""}
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </ListItem>
                      );
                    })
                  ) : (
                    <Typography sx={{ p: 2, color: "#888", textAlign: "center" }}>
                      No People Found!
                    </Typography>
                  )
                }
              </List>
            )
          }



        </Box>

      </Box>

      {/* Chat Area */}

      {
        NetworkingLoss && isOnline ? (<Box
          sx={{
            width: "75%",
            height: "100vh",
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >


          {selectedUser && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                pb: 1,
                mb: 2,
                borderBottom: "1px #e0e0e0 solid",
              }}
            >
              <Avatar sx={{ backgroundColor: "purple", height: 34, width: 34, fontSize: "14px" }}>
                {selectedUser.fullName?.charAt(0)}
              </Avatar>
              <Box sx={{ ml: 1 }}>
                <Typography
                  sx={{ fontWeight: "bold", fontSize: "14px", color: "#53389E" }}
                >
                  {selectedUser.fullName}
                </Typography>
                <Typography sx={{ fontSize: "12px", color: '#14960B' }}>
                  {selectedUser.userRole || selectedUser?.roleName}
                </Typography>
              </Box>
              <Box sx={{ ml: "auto", display: "flex", alignItems: "center" }}>
                <Chip
                  size="small"
                  label={isConnected ? "Online" : "Offline"}
                  color={isConnected ? "success" : "error"}
                />
              </Box>
            </Box>
          )}

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              p: 2,
              "&::-webkit-scrollbar": { width: "3px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "3px",
              },
              backgroundImage: `url(${OR_Logo})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: '100% 50%',
            }}
          >
            <Box
              ref={chatContainerRef}
              sx={{
                overflowY: "auto",
                px: 2,
                py: 1,
                // backgroundColor: "#fff",
              }}
            >

              {/* 2. Keep all grouped messages inside this container */}
              {Object.keys(groupedMessages).map((dateKey) => {
                const formattedDate = dayjs(dateKey).isToday()
                  ? "Today"
                  : dayjs(dateKey).isYesterday()
                    ? "Yesterday"
                    : dayjs(dateKey).format("DD MM YYYY");

                return (
                  <React.Fragment key={dateKey}>
                    <Box sx={{ display: "flex", justifyContent: "center", my: 1 }}>
                      <Typography
                        variant="caption"
                        sx={{
                          px: 2,
                          py: 0.5,
                          borderRadius: "8px",
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#555",
                        }}
                      >
                        {formattedDate}
                      </Typography>
                    </Box>

                    {groupedMessages[dateKey].map((msg, index) => (
                      <Box key={index} sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            display: "block",
                            alignSelf: msg.sender === user ? "flex-end" : "flex-start",
                            textAlign: "right",
                          }}
                        >
                          {msg.timestamp ? formatToIST(msg.timestamp) : "-"}
                        </Typography>

                        <Box
                          sx={{
                            alignSelf: msg.sender === user ? "flex-end" : "flex-start",
                            backgroundColor: msg.sender === user ? "#c9bde6ff" : "#f0f0f0",
                            borderRadius: "8px",
                            p: 1.5,
                            mb: 1,
                            maxWidth: "55%",
                            wordWrap: "break-word",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontFamily: "emoji",
                              fontSize: "16px",
                              whiteSpace: "normal",
                            }}
                          >
                            {msg.content}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </React.Fragment>
                );
              })}

            </Box>

          </Box>

          {/* Input */}

          {
            (userList?.length > 0 || selectedUser) && (
              <Box
                sx={{
                  position: "sticky",
                  bottom: 0,
                  background: "rgba(255,255,255,0.3)",
                  backdropFilter: "blur(10px)",
                  borderTop: "1px solid rgba(0,0,0,0.08)",
                  py: 1.5,
                  px: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                    maxWidth: "900px",
                  }}
                >
                  {/* 📎 Attachment Button */}
                  {/* <Tooltip title="Attach file">
                    <AttachmentIcon
                      sx={{
                        fontSize: 24,
                        color: "#6b7280",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        "&:hover": { color: "#185a9d", transform: "scale(1.1)" },
                      }}
                      onClick={() => {
                        if (isConnected) {
                          // Your attachment logic here
                        }
                      }}
                    />
                  </Tooltip> */}

                  {/* 💬 Message Input */}
                  <Box sx={{ position: "relative", flex: 1 }}>
                    <TextField
                      variant="outlined"
                      placeholder={isConnected ? "Type a message..." : "Disconnected"}
                      multiline
                      maxRows={2}
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      onKeyPress={handleKeyPress}
                      disabled={!isConnected}
                      fullWidth
                      InputProps={{
                        sx: {
                          borderRadius: "9999px",
                          background: "rgba(255,255,255,0.7)",
                          backdropFilter: "blur(6px)",
                          height: "48px",
                          px: 2,
                          pr: 8,
                          boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: "rgba(255,255,255,0.85)",
                          },
                          "&.Mui-focused": {
                            boxShadow: "0 0 0 3px rgba(67,206,162,0.2)",
                            borderColor: "rgba(67,206,162,0.5)",
                          },
                          textarea: {
                            overflow: "hidden",
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 2,
                            whiteSpace: "pre-wrap",
                          },
                        },
                      }}
                    />

                    {/* 😊 Emoji Icon */}
                    <Tooltip title="Add emoji">
                      <span
                        style={{
                          position: "absolute",
                          right: "45px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#6b7280",
                          transition: "all 0.3s ease",
                        }}
                        onClick={() => {
                          if (isConnected) {
                            // your emoji picker logic
                          }
                        }}
                      >
                        {/* <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                          <line x1="9" y1="9" x2="9.01" y2="9" />
                          <line x1="15" y1="9" x2="15.01" y2="9" />
                        </svg> */}
                      </span>
                    </Tooltip>
                  </Box>

                  {/* 🚀 Send Button */}
                  <span
                    style={{
                      width: '52px',
                      height: '52px',
                      borderRadius: '50%',
                      background: message.trim() && isConnected
                        ? 'linear-gradient(135deg, #502e9aff 0%, #e662e0ff 100%)'
                        : 'linear-gradient(135deg, #666 0%, #999 100%)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: message.trim() && isConnected ? 'pointer' : 'not-allowed',
                      opacity: message.trim() && isConnected ? 1 : 0.6,
                      boxShadow: message.trim() && isConnected
                        ? '0 4px 12px rgba(127, 86, 217, 0.4)'
                        : '0 4px 12px rgba(0,0,0,0.25)',
                      transition: 'all 0.3s ease',
                      transform: message.trim() && isConnected ? 'scale(1)' : 'scale(0.95)',
                    }}
                    onMouseEnter={(e) => {
                      if (message.trim() && isConnected) {
                        e.currentTarget.style.transform = 'scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(127, 86, 217, 0.6)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (message.trim() && isConnected) {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(127, 86, 217, 0.4)';
                      }
                    }}
                    onClick={() => {
                      if (message.trim() && isConnected) {
                        sendMessage();
                      }
                    }}
                  >
                    <FiSend
                      style={{
                        fontSize: '17px',
                        color: '#fff',
                      }}
                    />
                  </span>
                </Box>
              </Box>
            )
          }
        </Box>) : (
          <Networking />)
      }



    </Box>
  );
};

export default UserChat;
